import { createApp } from "vue";
import App from "@/App.vue";
import { store } from "./store/store";
import vuetify from "./plugins/vuetify";
import router from "./router";
import mcModel from "@maersk-global/mds-vue-mc-model";
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

const app = createApp(App);

app.directive("mc-model", mcModel);
app.config.ignoredElements = [/^mc-/];

app.use(vuetify)
app.use(store)
app.use(router)
app.mount("#app");
